/* eslint-disable no-console */
import Vue from 'vue'

import { register } from 'register-service-worker'
import { apolloClient } from '@/graph/apollo'

import { pushNotification } from '@/utils/pushNotification'

import { UPCOMING_ORDERS_SUBSCRIPTION } from '@/graph/gql/orders.gql'

const { $isSeller } = Vue.prototype

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered() {
      console.log('Service worker has been registered.')

      if ($isSeller) {
        // Subscribe to upcoming orders
        apolloClient.subscribe({
          query: UPCOMING_ORDERS_SUBSCRIPTION,
          next(result) {
            // TODO: display order info
            pushNotification({
              title: 'Pona Seller',
              body: 'New order recieved'
            })
          }
        })
      }
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated() {
      console.log('New content is available; please refresh.')
    },
    offline() {
      console.log(
        'No internet connection found. App is running in offline mode.'
      )
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
